module.exports = __webpack_public_path__ + "img/partners.2f1fb2c5.png";